import { Heading, IconButton, VStack, useColorMode } from "@chakra-ui/react";
import "./App.css";
import AddTodo from "./componants/AddTodo";
import { FaSun, FaMoon } from "react-icons/fa";
import { useEffect, useState } from "react";
import Todos from "./componants/Todos";

function App() {
  const { colorMode, toggleColorMode } = useColorMode();
  const [Data, setData] = useState(
    () => JSON.parse(localStorage.getItem("todos")) || []
  );
    useEffect(() => {
      localStorage.setItem("todos", JSON.stringify(Data));
    }, [Data]);


  const addTodos = (val) => {
    setData([...Data, val]);
  };
  // console.log(Data);
  const deleteTodo = (id) => {
    const delTodo = Data.filter((item) => {
      return item.id !== id;
    });
    setData(delTodo);
  };


  const togglestatus = (id) => {
    const updatedItems = Data.map((item) => {
      if (item.id === id) {
        return { ...item, status: !item.status }
      }
      return item;
    });
    setData(updatedItems);
  }

  return (
    <VStack p={4}>
      <IconButton
        icon={colorMode === "light" ? <FaSun /> : <FaMoon />}
        isRound="true"
        size="lg"
        alignSelf="flex-end"
        onClick={toggleColorMode}
      />
      <Heading
        mb="8"
        fontWeight="extrabold"
        size="2xl"
        bgGradient="linear(to-r, pink.500, pink.300, blue.500)"
        bgClip="text">
        Todo Application
      </Heading>
      <Todos Data={Data} deleteTodo={deleteTodo} togglestatus={togglestatus} />
      <AddTodo addTodos={addTodos} colorMode={colorMode} />
    </VStack>
  );
}

export default App;
